import { PageHeader, Spin } from "antd";
import * as React from "react";
import { PageProps } from "../../../core/ui/pages/Page";
import { ICaseLawDocumentCreationPresenter } from "../../presenter/CaseLawDocumentCreationPresenter";
import CaseLawDocumentForm from "../components/CaseLawDocumentForm";

export interface Props extends PageProps {}
export interface State extends ICaseLawDocumentCreationPresenter {
  courtCaseValidationStatus: "error" | "";
  courtCaseHelpText: string;
}

export default class CaseLawDocumentCreationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
    this.onRaiseValidationError = this.onRaiseValidationError.bind(this);
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  onRaiseValidationError(errors) {
    if (errors) {
      this.setState({
        courtCaseValidationStatus: "error",
        courtCaseHelpText: this.state.translate(
          "editors.case_decisions.decision_date_required_message"
        )
      });
    } else {
      this.setState({
        courtCaseValidationStatus: "",
        courtCaseHelpText: ""
      });
    }
  }

  render() {
    const {
      organisations,
      caseLawDocumentTypes,
      organisationIndexes,
      caseLawDocumentTypeId,
      selectedIndex,
      setOrganisationId,
      translate,
      createCaseLawDocument,
      showCaseLawDocumentList,
      connectedCourtCasesList,
      createConnectedCourtCase,
      removeConnectedCourtCase,
      findCourtCaseDetails,
      courtCase,
      user,
      setCaseLawDocumentTypeCode,
      parentGroupList,
      secondGroupList,
      selectedParentGroupId,
      selectedSecondGroupId,
      setParentGroupId,
      setSecondGroupId,
      setInvalidatePublishedCaseLawDocuments,
      publishedCaseLawDocuments,
      onSearch,
      invalidatePublishedCaseLawDocsVisible,
      selectedOrganisationId,
      courtCaseDetailsModalVisible,
      updateCourtCaseDetailsModalVisibility,
      updateCourtCaseSelection,
      courtCaseSelectionResult,
      store,
      courtCaseConnectionTypeList,
      createCourtCasePopupVisible,
      createCourtCaseModalVisible,
      showCreateCourtCasePopupVisible,
      showCreateCourtCaseModalVisible,
      createCourtCase,
      nonExistantCourtCaseNumber,
      createAttachment,
      courtCaseHelpText,
      courtCaseValidationStatus,
      uploadedAttachment,
      courtCaseTypes,
      decisionTypes,
      indexTypeAttributes,
      setAttributesData,
      indexAttributeDataList,
      closeIndexDataModal,
      openIndexDataModal,
      indexDataModalVisible,
      saveAttributeData,
      selectedIndexForAttribute
    } = this.state;
    return (
      <>
        <PageHeader
          className="site-page-header"
          title={translate("editors.case_law_documents.case_law_document")}
          subTitle={translate("editors.case_law_documents.new_title")}
        />
        <Spin spinning={this.state.loaders.caseLawDocumentLoader || false}>
          <CaseLawDocumentForm
            uploadedAttachment={uploadedAttachment}
            courtCaseSelectionResult={courtCaseSelectionResult}
            updateCourtCaseSelection={updateCourtCaseSelection}
            courtCaseDetailsModalVisible={courtCaseDetailsModalVisible}
            parentGroupList={parentGroupList}
            secondGroupList={secondGroupList}
            selectedParentGroupId={selectedParentGroupId}
            selectedSecondGroupId={selectedSecondGroupId}
            setParentGroupId={setParentGroupId}
            setSecondGroupId={setSecondGroupId}
            translate={translate}
            showCaseLawDocumentList={showCaseLawDocumentList}
            caseLawDocumentTypes={caseLawDocumentTypes}
            organisations={organisations}
            setOrganisationId={setOrganisationId}
            organisationIndexes={organisationIndexes}
            connectedCourtCasesList={connectedCourtCasesList}
            createConnectedCourtCase={createConnectedCourtCase}
            removeConnectedCourtCase={removeConnectedCourtCase}
            selectedIndex={selectedIndex}
            organisationCaseLawDocumentTypeId={caseLawDocumentTypeId}
            onSubmit={createCaseLawDocument}
            findCourtCaseDetails={findCourtCaseDetails}
            courtCase={courtCase}
            user={user}
            setCaseLawDocumentTypeCode={setCaseLawDocumentTypeCode}
            setInvalidatePublishedCaseLawDocuments={
              setInvalidatePublishedCaseLawDocuments
            }
            publishedCaseLawDocuments={publishedCaseLawDocuments}
            onSearch={onSearch}
            invalidatePublishedCaseLawDocsVisible={
              invalidatePublishedCaseLawDocsVisible
            }
            selectedOrganisationId={selectedOrganisationId}
            store={store}
            onHideCourtCaseDetailsModal={() =>
              updateCourtCaseDetailsModalVisibility(false)
            }
            loaders={this.state.loaders}
            courtCaseConnectionTypeList={courtCaseConnectionTypeList}
            createCourtCasePopupVisible={createCourtCasePopupVisible}
            createCourtCaseModalVisible={createCourtCaseModalVisible}
            showCreateCourtCasePopupVisible={showCreateCourtCasePopupVisible}
            showCreateCourtCaseModalVisible={showCreateCourtCaseModalVisible}
            createCourtCase={createCourtCase}
            nonExistantCourtCaseNumber={nonExistantCourtCaseNumber}
            createAttachment={createAttachment}
            courtCaseHelpText={courtCaseHelpText}
            courtCaseValidationStatus={courtCaseValidationStatus}
            onRaiseValidationError={this.onRaiseValidationError}
            courtCaseTypes={courtCaseTypes}
            decisionTypes={decisionTypes}
            indexTypeAttributes={indexTypeAttributes}
            setAttributesData={setAttributesData}
            indexAttributeDataList={indexAttributeDataList}
            closeIndexDataModal={closeIndexDataModal}
            openIndexDataModal={openIndexDataModal}
            indexDataModalVisible={indexDataModalVisible}
            saveAttributeData={saveAttributeData}
            selectedIndexForAttribute={selectedIndexForAttribute}
          />
        </Spin>
      </>
    );
  }
}
